import { Input } from "antd";
import type { ChangeEvent, FC } from "react";
import { useCallback } from "react";

import { getAssignedDataGroup } from "../../../../core/router/auth";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { SecondaryButton } from "../../../Buttons/components/ActionButton";
import { IconCodes } from "../../../Icon/IconCodes";
import { Icon } from "../../../index";
import { useLazyLoadConfigValueQuery } from "../../services/server/formComponentsApi";
import type { AntCustomFormField } from "../../types/types";
import { buttonStyle, inputStyle } from "./buttonGeneratorStyle";

interface InputGeneratorProps extends AntCustomFormField<string> {
    label: string;
    readOnly: boolean;
    name: string;
    siteGroupId: number;
}

export const SiteIdGenerator: FC<InputGeneratorProps> = ({ siteGroupId, readOnly, onChange, ...restProps }) => {
    const onValueChange = (ev: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };

    const [data, { isFetching }] = useLazyLoadConfigValueQuery();

    const onClick = useCallback(() => {
        if (onChange) {
            const urlToFetchOptions = `/${ResourceName.SITE_ID_GENERATOR}?siteGroupId=${siteGroupId}`;
            data(urlToFetchOptions)
                .unwrap()
                .then((response) => {
                    if (response.value) {
                        onChange(response.value);
                    }
                });
        }
    }, [siteGroupId, data, onChange]);

    const dataGroup = getAssignedDataGroup();
    const disableButton: boolean = !(dataGroup?.siteIdMinLength && dataGroup?.siteIdMaxLength && dataGroup?.siteIdPrefixes);

    return (
        <Input.Group compact>
            <Input readOnly={readOnly || isFetching} onChange={onValueChange} style={inputStyle} {...restProps} />
            <SecondaryButton
                name="siteIdGenerator_button"
                onClick={onClick}
                disabled={readOnly || isFetching || disableButton}
                icon={<Icon iconName={IconCodes.RedoOutlined} />}
                style={buttonStyle}
            />
        </Input.Group>
    );
};
